import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';

const routes: Routes = [
  {
    path: '',
    component: MyAccountComponent,
    data: { title: routeMetaData.myAccount.title },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyAccountRoutingModule {}
